export enum DeviceSessionRefsKey {
  VISIT_ID = 'VISIT_ID',
  REQUEST_TAG_V1 = 'REQUEST_TAG_V1',
}
